<template>
    <div>
        <v-card>
            <v-container>
                <v-row>
                    <v-col cols="9" v-if="respaldo == 1">
                        <v-file-input
                            label="Adjunte aqui el archivo de soporte o respaldo"
                            outlined
                            v-model="chosenFile"
                            >
                        </v-file-input>
                    </v-col>
                    <v-col cols="3">
                        <v-btn color="primary" @click="onFileCharge" v-if="chosenFile !== null && chosenFile !== undefined">
                            Subir Archivo
                        </v-btn>                        
                    </v-col>
                </v-row>
                <v-timeline>
                    <v-timeline-item v-for='arc in archivos' :key="arc.id">
                                <template v-slot:icon>
                                <v-avatar>
                                    <img :src="arc.emp.imagen_usuario">
                                </v-avatar>
                                </template>
                        <span slot="opposite">
                            {{arc.etapaname}}
                            <p>{{momento(arc.fecha)}}</p>
                        </span>
                            <v-card class="elevation-10">
                            <v-card-title class="headline">{{arc.alias}}</v-card-title>
                            <v-card-text>
                                <p>{{arc.emp.nombres}} {{arc.emp.apellidos}}</p>
                                <a :href="arc.archivo">{{arc.nombre}}</a>
                            </v-card-text>
                            </v-card>
                    </v-timeline-item>
                </v-timeline>
            </v-container>
        </v-card>
    </div>
</template>
<script>
import moment from "moment";
moment.locale('es');
export default {
    data() {
        return {
            chosenFile: null,
        }
    },
  props: {
    archivos: {
      type: Array,
      default: null
    },
    respaldo: {
        type: Number,
        default: 0
    },
  },
  methods: {
    //Metodo que se trae la informacion de la fecha formato mysql y la retorna local
    momento(fecha){
      return moment(fecha).format('L')
    },
    //empuja el archivo al componente padre
    onFileCharge(){
        this.$emit('cargaArchivos',this.chosenFile)
        this.chosenFile = null
    },
  },
}
</script>